// src/api/modulesApi.js
import axios from "axios";

export const updateNoti = async (id, updatedData) => {
  try {
    const response = await axios.put(`http://localhost:8080/webnet-hms/api/notifications/${id}`, updatedData);
    console.log(response.data);
  } catch (error) {
    window.alert("Error updating notifications:", error);
    throw error;
  }
};
